import { render, staticRenderFns } from "./ReportisticaPerito.vue?vue&type=template&id=536e4c1d"
import script from "./ReportisticaPerito.vue?vue&type=script&lang=js"
export * from "./ReportisticaPerito.vue?vue&type=script&lang=js"
import style0 from "./ReportisticaPerito.vue?vue&type=style&index=0&id=536e4c1d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports